module.exports = __webpack_public_path__ + "img/1.948b9592.png";